<template>
    <section class="container-fluid" :id="'promotions_table_' + id">
        <div class="brand_review_promotions_table row">
            <template v-for="(offer, index) in offers">
                <div class="col-12 col-lg-2 p-0" :key="offer.rand + '_state'">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-6 col-lg-12 d-flex align-items-center title">
                                <p class="m-0">US State</p>
                            </div>
                            <div class="col-6 col-lg-12 d-flex align-items-center value">
                                <p class="m-0" v-html="state"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-2 p-0" :key="offer.rand + '_type'">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-6 col-lg-12 d-flex align-items-center title">
                                <p class="m-0">Type</p>
                            </div>
                            <div class="col-6 col-lg-12 d-flex align-items-center value">
                                <p class="m-0">{{ offer.product_type }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-2 p-0" :key="offer.rand + '_expiry'">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-6 col-lg-12 d-flex align-items-center title">
                                <p class="m-0">Expiration Date</p>
                            </div>
                            <div class="col-6 col-lg-12 d-flex align-items-center value">
                                <p class="m-0" v-html="offerExpiry()"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-2 p-0" :key="offer.rand + '_matched'">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-6 col-lg-12 d-flex align-items-center title">
                                <p class="m-0">Matched Amount</p>
                            </div>
                            <div class="col-6 col-lg-12 d-flex align-items-center value">
                                <p class="m-0" v-html="offerAmount(offer)"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-2 p-0" :key="offer.rand + '_code'">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-6 col-lg-12 d-flex align-items-center title">
                                <p class="m-0">Promo Code</p>
                            </div>
                            <div class="col-6 col-lg-12 d-flex align-items-center value">
                                <p class="m-0" v-html="offerPromoCode(offer)"></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-2 p-0" :key="offer.rand + '_claim'">
                    <div class="container-fluid">
                        <div class="row border-0">
                            <div class="col-6 col-lg-12 d-none d-lg-flex align-items-center title">
                                <p class="m-0">{{ offerCta(offer) }}</p>
                            </div>
                            <div class="col-lg-12 d-flex align-items-center justify-content-around justify-content-lg-start p-0 value">
                                <a
                                    :href="offerExitLink(offer)| appendfragment('cta', ctaLocation + '_pos_' + (index + 1))"
                                    class="us_play_now_btn exit-page-link d-flex justify-content-around align-items-center text-decoration-none exit-click-cta"
                                    target="_blank"
                                    rel="nofollow"
                                    :data-gtm="offerGTM(offer, index)"
                                    data-kt="cta:a|ctalocation|operator|product|position|brand_id|brand_product_id|offer_id|site_offer_id"
                                    :data-ctalocation="ctaLocation + '_pos=' + (index + 1)"
                                    :data-operator="brand.brand"
                                    :data-product="brand.brand + ' ' + offer.product_type"
                                    :data-brand_id="brand.id"
                                    :data-brand_product_id="offer.brand_product_id"
                                    :data-offer_id="offer.offer_id"
                                    :data-site_offer_id="offer.site_offer_id"
                                    :data-position="index + 1"
                                >{{ offerCta(offer) }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 terms" :key="offer.rand + '_terms'">
                    <span>{{ offer.offer_terms_conditions }}</span>
                </div>
            </template>
            <div v-if="!offers.length" class="row promo_table_row">
                <div class="col promo_table_col" style="border-bottom: none">
                    <div class="promotions_table_cell">
                        <div class="cell_inner" v-if="state">
                            <p style="text-alight: center">Offers not available in {{ state }}</p>
                        </div>
                        <div class="cell_inner" v-else>
                            <p style="text-alight: center">
                                Please select a state in order to see offers
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'us-brand-offer-table',
    props: {
        brand: {
            type: Object,
            required: true,
        },
        brandProduct: {
            type: Object,
            default: () => {},
        },
        showSearch: {
            type: Boolean,
            default: true,
        },
        state: {
            type: String,
            required: true,
        },
        ctaLocation: {
            type: String,
            required: false,
            default: 'brand_review_bonus'
        }
    },
    watch: {
        state() {
            this.populateOffersFromProducts();
        }
    },
    mounted() {
        this.populateOffersFromProducts();
    },
    data() {
        return {
            offers: [],
            id: Math.floor(Math.random() * 1000000),
        };
    },
    methods: {
        populateOffersFromProducts() {
            let offers = [];
            this.offers = [];
            this.brand.products.forEach(product => {
                if (typeof product.offers === 'object') {
                    product.offers.forEach(offer => {
                        offer.us_states.forEach(state => {
                            if (state.code == this.state && offer.default_site_offer == true) {
                                offer.product_type = product.product_type;
                                offer.brand_product_id = product.brand_product_id;
                                offers.push(offer);
                            }
                        });
                    });
                }
            });
            offers = offers.flat(Infinity);
            offers.forEach( offer => {
                if (this.hasValidDestinationUrl(offer)) {
                    this.offers.push(offer);
                }
            });

            if(this.offers.length < 1 && this.state !== 'NJ'){
                this.$emit('update-states', 'NJ');
            }
        },
        offerExpiry() {
            let today = new Date();
            return today.getFullYear()+'-'+`${today.getMonth() + 2}`.padStart(2, "0")+'-'+ 15;
        },
        offerAmount(offer) {
            if (offer.offer_size === 'No Limit') {
                return offer.offer_size;
            } else {
                let offerLabel =
                    offer.currency_symbol === 'kr'
                        ? offer.offer_size + offer.currency_symbol
                        : offer.currency_symbol + offer.offer_size;

                return !!offer.offer_size ? offerLabel : '-';
            }
        },
        offerCta(offer) {
            if(offer.product_type == 'Betting') {
                return 'Bet Now';
            }
            return 'Play Now';
        },
        offerPromoCode(offer) {
            if (typeof offer.promo !== 'object') {
                return '-';
            }
            return offer.promo.code ? offer.promo.code : offer.promo.label;
        },
        hasValidDestinationUrl(offer) {
            return !!offer.destination_url;
        },
        offerExitLink(offer) {
            return offer.exit_page.link;
        },
        offerExitLinkLabel(offer) {
            return offer.exit_page.label;
        },
        offerGTM(offer, index) {
            let promo_type = this.brandProduct && typeof(this.brandProduct) === undefined ? 'brand-promos-' : 'brandproduct-promos-';
            return (promo_type + this.brand.brand + '-pos=' + (index + 1) + '-state ' + this.state.toLowerCase());
        },
    },
};
</script>